import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.43.46 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V143_46: ChangelogAdvancedPayload = {
  omitTabNavigation: true,
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v14346",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v14346",
  stats: [
    {
      value: 3,
      labelKey: "changelog.advanced.stat.agenda",
      accentColor: "#0F6E56"
    }
  ],
  tabs: [
    {
      id: "agenda",
      labelKey: "changelog.advanced.tab.agenda",
      count: 3,
      accentColor: "#185FA5",
      kind: "video",
      youtubeVideoId: "nqfcAO3LgTY",
      videoHeadingKey: "changelog.advanced.v14346.video.heading",
      videoCaptionKey: "changelog.advanced.v14346.video.caption",
      youtubeOpenLabelKey: "changelog.advanced.v14346.video.openYoutube",
      bulletsAfterVideoLabelKey:
        "changelog.advanced.v14346.video.detailsHeading",
      items: [
        {
          textKey: "changelog.advanced.v14346.agenda.1"
        },
        {
          textKey: "changelog.advanced.v14346.agenda.2"
        },
        {
          textKey: "changelog.advanced.v14346.agenda.3"
        }
      ]
    }
  ]
};
